import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import setSearchUrl from '../actions/setSearchUrl';


class ActiveFilters extends Component {
    render ( props ) {

        const {
            activeCategoriesObj,
            activeCategories,
            activeTools,
            activeToolsObj,
            queryValue,
        } = this.props.state;

        const resetCategory = ( id ) => {

            let cat = id.toString();

            let activeCats = activeCategories.split( ',' );
            let cats = activeCats.filter( c => c !== cat );

            if ( cats.length > 0 ) {
                this.props.dispatch( setSearchUrl( 'categories', cats.join(), null ) )
            } else {
                this.props.dispatch( setSearchUrl( null, null, 'categories' ) )
            }
        }

        const resetTool = ( id ) => {

            let tool = id.toString();

            let activeToolz = activeTools.split( ',' );
            let tools = activeToolz.filter( t => t !== tool );

            if ( tools.length > 0 ) {
                this.props.dispatch( setSearchUrl( 'tech', tools.join(), null ) )
            } else {
                this.props.dispatch( setSearchUrl( null, null, 'tech' ) )
            }
        }

        return (
            <>
                { (activeCategoriesObj.length > 0 || activeToolsObj.length > 0) &&
                    <div className="c-search__selected">
                        <div className="c-form-group">
                            <h2 className="c-facets__title">
                                Je gekozen filters:
                            </h2>
                            <div className="o-flex o-flex-wrap">
                                {
                                    activeCategoriesObj.map( ( activeCat ) =>
                                        <button onClick={ e => { resetCategory( activeCat.id ); } }>{ activeCat.label }</button>
                                    )
                                }
                                {
                                    activeToolsObj.map( ( activeTool ) =>
                                        <button onClick={ e => { resetTool( activeTool.id ); } }>{ activeTool.label }</button>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}

function mapStateToProps ( state ) {
    return { state };
}

export default connect( mapStateToProps )( ActiveFilters );